import { render, staticRenderFns } from "./SectionIntro.vue?vue&type=template&id=c560e376&scoped=true"
import script from "./SectionIntro.vue?vue&type=script&lang=ts"
export * from "./SectionIntro.vue?vue&type=script&lang=ts"
import style0 from "./SectionIntro.vue?vue&type=style&index=0&id=c560e376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c560e376",
  null
  
)

export default component.exports